import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

 
import ErrorBoundary from "./Components/ErrorBoundary";

import { getEmailLogged } from "./Store/Actions/API/authActions";

const RELEASE = process.env.REACT_APP_SENTRY_RELEASE;

if(process.env.NODE_ENV  === "production" ){
    const sessionReplayTracking = sessionReplayPlugin({
      forceSessionTracking: false,
      sampleRate: 1,
    });

    amplitude.add(sessionReplayTracking);
    
    // Your existing initialization logic with Browser SDK
    amplitude.init('df053c6691c18d4258751033d5474a27',getEmailLogged(), {
      fetchRemoteConfig: true,
      autocapture: { elementInteractions: true },
    });
}

if (process.env.NODE_ENV === "production" && RELEASE) {
  Sentry.init({
    dsn:
      "https://02e8c026fa2e406091c02f4a9b7497e2@o443341.ingest.sentry.io/5428529",
    release: RELEASE,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  });

  Sentry.configureScope((scope) => {
    scope.setUser({
      email: getEmailLogged(),
    });
  });
}

ReactDOM.render(
  <Sentry.ErrorBoundary
    fallback={({ resetError }) => <ErrorBoundary reset={resetError} />}
  >
    <App />
  </Sentry.ErrorBoundary>,
  document.getElementById("root")
);
